import Component from '@glimmer/component';
import { t } from 'ember-intl';
import can from 'ember-can/helpers/can';
import { HdsLinkInline } from '@hashicorp/design-system-components/components';
import { ZeroState } from 'core/components';

/**
 *
 * `PageHvnPeeringsListZeroStateComponent` renders Zero State component.
 *
 *
 * ```
 * <Page::HvnPeerings::List::ZeroState />
 * ```
 *
 * @class PageHvnPeeringsListZeroStateComponent
 *
 */
export default class PageHvnPeeringsListZeroState extends Component {
  get peerings() {
    return [];
  }
  get provider() {
    return this.args.provider;
  }
  <template>
    <ZeroState as |ZS|>
      <ZS.Header>
        {{t "components.page.hvn-peerings.list.empty.header"}}
      </ZS.Header>
      <ZS.Message>
        {{t
          "components.page.hvn-peerings.list.empty.message"
          provider=this.provider
        }}
      </ZS.Message>
      {{#if (can "create network-peering" this.peerings)}}
        <ZS.Action>
          <HdsLinkInline
            @route="cloud.orgs.detail.projects.detail.hvns.detail.peerings.create"
          >
            {{t "components.page.hvn-peerings.list.empty.action"}}
          </HdsLinkInline>
        </ZS.Action>
      {{/if}}
    </ZeroState>
  </template>
}
